import { Person, TypedEntity } from "./common";

export interface IAuditLogResponse {
  auditLogs: IAuditTransaction[];
}

export interface IErrorLogResponse {
  errorLogs: IErrorLog[];
}

export interface IAuditTransaction {
  trxId: string;
  userId: string;
  user: Person;
  logs: IAuditLog[];
}

export interface IAuditLog {
  id: number;
  ts: string;
  actionType: string;
  changeType: string;
  entity: TypedEntity;
  field: string;
  oldValue: string;
  newValue: string;
}

export const AuditActionType: Record<string, string> = {
  C: 'New',
  E: 'Expired',
  U: 'Update',
  UM: 'Update',
  D: 'Delete',
};

export const AuditChangeType: Record<string, string> = {
  R: 'Relationship',
  A: 'Attribute(s)',
};

export interface IErrorLog {
  id: number;
  trxId: string;
  createTimestamp: string;
  entityType: string;
  entity: string;
  logDetail: string;
  createUser: string;
}

export interface IPublishStep {
  serialId: number;
  step: number;
  stepDef: string;
  startDate: string;
  endDate: string;
  result: boolean;
  log: string;
}
export interface IPublishHistory {
  publishHistoryId: number;
  publishSteps: IPublishStep[]
}

export interface IPublishHistoryResponse {
  publishHistoryLogs: IPublishHistory[];
}
